const l = {
  "cdr-table": "cdr-table_15-1-0",
  "cdr-table--small": "cdr-table--small_15-1-0",
  "cdr-table--medium": "cdr-table--medium_15-1-0",
  "cdr-table--large": "cdr-table--large_15-1-0",
  "cdr-table--striped": "cdr-table--striped_15-1-0",
  "cdr-table--border": "cdr-table--border_15-1-0",
  "cdr-table--full-width": "cdr-table--full-width_15-1-0",
  "cdr-table--responsive": "cdr-table--responsive_15-1-0",
  "cdr-table--hover": "cdr-table--hover_15-1-0",
  "cdr-table--full-width@xs": "cdr-table--full-width@xs_15-1-0",
  "cdr-table--full-width@sm": "cdr-table--full-width@sm_15-1-0",
  "cdr-table--full-width@md": "cdr-table--full-width@md_15-1-0",
  "cdr-table--full-width@lg": "cdr-table--full-width@lg_15-1-0"
};
export {
  l as default
};
